// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_usage.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { App } from "./app";
import { Any } from "../../../../google/protobuf/any";
import { AppUserView } from "./app_user";
import { AppUserExpandMask } from "./app_user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
/**
 * The AppUsageControls object describes some peripheral configuration for an app.
 *
 * @generated from protobuf message c1.api.app.v1.AppUsageControls
 */
export interface AppUsageControls {
    /**
     * The app that this object belongs to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * Whether or not to notify some if they have access to the app, but has not used it within a configurable amount of time.
     *
     * @generated from protobuf field: bool notify = 2;
     */
    notify: boolean;
    /**
     * The duration in days after which we notify users of nonusage.
     *
     * @generated from protobuf field: uint32 notify_after_days = 3;
     */
    notifyAfterDays: number;
    /**
     * Whether or not to revoke a grant if they have access to the app, but has not used it within a configurable amount of time.
     *
     * @generated from protobuf field: bool revoke = 4;
     */
    revoke: boolean;
    /**
     * The duration in days after which we revoke users that have not used that grant.
     *
     * @generated from protobuf field: uint32 revoke_after_days = 5;
     */
    revokeAfterDays: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppUsageControlsRequest
 */
export interface GetAppUsageControlsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * The GetAppUsageControlsResponse message contains the retrieved AppUsageControls object.
 *
 * @generated from protobuf message c1.api.app.v1.GetAppUsageControlsResponse
 */
export interface GetAppUsageControlsResponse {
    /**
     * The AppUsageControls is null if HasUsageData is false, or data if it's true.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUsageControls app_usage_controls = 1;
     */
    appUsageControls?: AppUsageControls;
    /**
     * HasUsageData is false if the access entitlement for this app has no usage data.
     *
     * @generated from protobuf field: bool has_usage_data = 2;
     */
    hasUsageData: boolean;
}
/**
 * The UpdateAppUsageControlsRequest message contains the AppUsageControls object to update and the update mask.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppUsageControlsRequest
 */
export interface UpdateAppUsageControlsRequest {
    /**
     * The app usage controls object to update the request with.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUsageControls app_usage_controls = 1;
     */
    appUsageControls?: AppUsageControls;
    /**
     * A comma-separated list of fields to update in the destination. To update just the notify, it would look like "notify,notify_after_days".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * The UpdateAppUsageControlsResponse message contains the updated AppUsageControls object.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppUsageControlsResponse
 */
export interface UpdateAppUsageControlsResponse {
    /**
     * The AppUsageControls object that was updated.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUsageControls app_usage_controls = 1;
     */
    appUsageControls?: AppUsageControls;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetNotLoggedInCountRequest
 */
export interface GetNotLoggedInCountRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: uint32 days = 2;
     */
    days: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetNotLoggedInCountResponse
 */
export interface GetNotLoggedInCountResponse {
    /**
     * @generated from protobuf field: uint32 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchInactiveUsersRequest
 */
export interface SearchInactiveUsersRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_owner_id = 2;
     */
    appOwnerId: string;
    /**
     * @generated from protobuf field: uint32 days = 3;
     */
    days: number;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 6;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchInactiveUsersResponse
 */
export interface SearchInactiveUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1;
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithUserCount
 */
export interface AppWithUserCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App App = 1 [json_name = "App"];
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 Count = 2 [json_name = "Count"];
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsRequest
 */
export interface SearchInactiveUsersPastThirtyDaysForAllAppsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsResponse
 */
export interface SearchInactiveUsersPastThirtyDaysForAllAppsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppWithUserCount list = 1;
     */
    list: AppWithUserCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountInactiveUsersPastThirtyDaysRequest
 */
export interface CountInactiveUsersPastThirtyDaysRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.CountInactiveUsersPastThirtyDaysResponse
 */
export interface CountInactiveUsersPastThirtyDaysResponse {
    /**
     * @generated from protobuf field: int64 total_count = 1;
     */
    totalCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountInactiveUsersForAppRequest
 */
export interface CountInactiveUsersForAppRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountInactiveUsersForAppResponse
 */
export interface CountInactiveUsersForAppResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppUsageControls$Type extends MessageType<AppUsageControls> {
    constructor() {
        super("c1.api.app.v1.AppUsageControls", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "notify_after_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 500, gte: 0 } } } },
            { no: 4, name: "revoke", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "revoke_after_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 500, gte: 0 } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUsageControls
 */
export const AppUsageControls = new AppUsageControls$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppUsageControlsRequest$Type extends MessageType<GetAppUsageControlsRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppUsageControlsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppUsageControlsRequest
 */
export const GetAppUsageControlsRequest = new GetAppUsageControlsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppUsageControlsResponse$Type extends MessageType<GetAppUsageControlsResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppUsageControlsResponse", [
            { no: 1, name: "app_usage_controls", kind: "message", T: () => AppUsageControls },
            { no: 2, name: "has_usage_data", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppUsageControlsResponse
 */
export const GetAppUsageControlsResponse = new GetAppUsageControlsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppUsageControlsRequest$Type extends MessageType<UpdateAppUsageControlsRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateAppUsageControlsRequest", [
            { no: 1, name: "app_usage_controls", kind: "message", T: () => AppUsageControls, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppUsageControlsRequest
 */
export const UpdateAppUsageControlsRequest = new UpdateAppUsageControlsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppUsageControlsResponse$Type extends MessageType<UpdateAppUsageControlsResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateAppUsageControlsResponse", [
            { no: 1, name: "app_usage_controls", kind: "message", T: () => AppUsageControls }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppUsageControlsResponse
 */
export const UpdateAppUsageControlsResponse = new UpdateAppUsageControlsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNotLoggedInCountRequest$Type extends MessageType<GetNotLoggedInCountRequest> {
    constructor() {
        super("c1.api.app.v1.GetNotLoggedInCountRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 366, gte: 0 } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetNotLoggedInCountRequest
 */
export const GetNotLoggedInCountRequest = new GetNotLoggedInCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNotLoggedInCountResponse$Type extends MessageType<GetNotLoggedInCountResponse> {
    constructor() {
        super("c1.api.app.v1.GetNotLoggedInCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetNotLoggedInCountResponse
 */
export const GetNotLoggedInCountResponse = new GetNotLoggedInCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInactiveUsersRequest$Type extends MessageType<SearchInactiveUsersRequest> {
    constructor() {
        super("c1.api.app.v1.SearchInactiveUsersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_owner_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$", ignoreEmpty: true } } } },
            { no: 3, name: "days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 366, gte: 0 } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchInactiveUsersRequest
 */
export const SearchInactiveUsersRequest = new SearchInactiveUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInactiveUsersResponse$Type extends MessageType<SearchInactiveUsersResponse> {
    constructor() {
        super("c1.api.app.v1.SearchInactiveUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchInactiveUsersResponse
 */
export const SearchInactiveUsersResponse = new SearchInactiveUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithUserCount$Type extends MessageType<AppWithUserCount> {
    constructor() {
        super("c1.api.app.v1.AppWithUserCount", [
            { no: 1, name: "App", kind: "message", jsonName: "App", T: () => App },
            { no: 2, name: "Count", kind: "scalar", jsonName: "Count", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithUserCount
 */
export const AppWithUserCount = new AppWithUserCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInactiveUsersPastThirtyDaysForAllAppsRequest$Type extends MessageType<SearchInactiveUsersPastThirtyDaysForAllAppsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsRequest
 */
export const SearchInactiveUsersPastThirtyDaysForAllAppsRequest = new SearchInactiveUsersPastThirtyDaysForAllAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInactiveUsersPastThirtyDaysForAllAppsResponse$Type extends MessageType<SearchInactiveUsersPastThirtyDaysForAllAppsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithUserCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsResponse
 */
export const SearchInactiveUsersPastThirtyDaysForAllAppsResponse = new SearchInactiveUsersPastThirtyDaysForAllAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountInactiveUsersPastThirtyDaysRequest$Type extends MessageType<CountInactiveUsersPastThirtyDaysRequest> {
    constructor() {
        super("c1.api.app.v1.CountInactiveUsersPastThirtyDaysRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountInactiveUsersPastThirtyDaysRequest
 */
export const CountInactiveUsersPastThirtyDaysRequest = new CountInactiveUsersPastThirtyDaysRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountInactiveUsersPastThirtyDaysResponse$Type extends MessageType<CountInactiveUsersPastThirtyDaysResponse> {
    constructor() {
        super("c1.api.app.v1.CountInactiveUsersPastThirtyDaysResponse", [
            { no: 1, name: "total_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountInactiveUsersPastThirtyDaysResponse
 */
export const CountInactiveUsersPastThirtyDaysResponse = new CountInactiveUsersPastThirtyDaysResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountInactiveUsersForAppRequest$Type extends MessageType<CountInactiveUsersForAppRequest> {
    constructor() {
        super("c1.api.app.v1.CountInactiveUsersForAppRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountInactiveUsersForAppRequest
 */
export const CountInactiveUsersForAppRequest = new CountInactiveUsersForAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountInactiveUsersForAppResponse$Type extends MessageType<CountInactiveUsersForAppResponse> {
    constructor() {
        super("c1.api.app.v1.CountInactiveUsersForAppResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountInactiveUsersForAppResponse
 */
export const CountInactiveUsersForAppResponse = new CountInactiveUsersForAppResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppUsageControlsService
 */
export const AppUsageControlsService = new ServiceType("c1.api.app.v1.AppUsageControlsService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/usage_controls", group: "App Usage Controls" }] } }, I: GetAppUsageControlsRequest, O: GetAppUsageControlsResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_usage_controls.app_id}/usage_controls", group: "App Usage Controls" }] } }, I: UpdateAppUsageControlsRequest, O: UpdateAppUsageControlsResponse },
    { name: "GetNotLoggedInCount", options: { "authz.method": { role: "VIEWER" } }, I: GetNotLoggedInCountRequest, O: GetNotLoggedInCountResponse },
    { name: "SearchInactiveUsers", options: { "authz.method": { role: "VIEWER" } }, I: SearchInactiveUsersRequest, O: SearchInactiveUsersResponse },
    { name: "CountInactiveUsersPastThirtyDays", options: { "authz.method": { role: "VIEWER" } }, I: CountInactiveUsersPastThirtyDaysRequest, O: CountInactiveUsersPastThirtyDaysResponse },
    { name: "SearchInactiveUsersPastThirtyDaysForAllApps", options: { "authz.method": { role: "VIEWER" } }, I: SearchInactiveUsersPastThirtyDaysForAllAppsRequest, O: SearchInactiveUsersPastThirtyDaysForAllAppsResponse },
    { name: "CountInactiveUsersForApp", options: { "authz.method": { role: "VIEWER" } }, I: CountInactiveUsersForAppRequest, O: CountInactiveUsersForAppResponse }
]);
